import React, { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { AddOUFormData } from "./validation.schema";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid2";
import { useGetSettings } from "@/hooks/useSetting";

type TabOrganizationAdditionalInfoProps = {
  editMode?: boolean;
};

export const TabOrganizationAdditionalInfo: FC<
  TabOrganizationAdditionalInfoProps
> = ({ editMode = false }) => {
  const { t } = useTranslation("organization");
  const { data: settings } = useGetSettings();

  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<AddOUFormData>();

  return (
    <Grid container spacing={"20px"}>
      <Grid size={6}>
        <Controller
          name="npi"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              id="npi"
              label={t("modals.label-npi")}
              variant="outlined"
              required={settings?.mandatoryNPI === "true"}
              value={field.value}
              onChange={(value) => field.onChange(value)}
              error={!!errors.npi}
              helperText={errors.npi ? errors.npi.message : null}
              fullWidth
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
